import React, { useState, useEffect } from 'react'
import { ButtonGroup, ButtonToolbar, Icon, IconButton, Panel, Table } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { downloadAuditIAp12Pdf } from '../../../redux/actions/auditReportSummary'
import notification from '../../../utils/notification'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { getReportsAudit, getReportsAuditIAP12Attch } from '../../../redux/actions/reportsAudit'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import DownloadButton from '../../../components/buttons/downloadButton/downloadButton'
import TooltipButton from '../../../components/buttons/TooltipButton'

export default function ReportsAuditIAP12Widget({
  auditId,
  shaded = true,
  collapsible = true,
  defaultExpanded = true,
  bordered = true,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoad, setIsLoad] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    handleGetSchema(auditId)
  }, [])

  const handleGetSchema = async (auditId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getReportsAuditIAP12Attch(auditId)
      // let response = { model: mock }
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleDownloadIAp12 = async (data, type) => {
    setIsLoad(true)
    startLoading()
    try {
      const file = await downloadAuditIAp12Pdf(data.filePath)
      // console.log('file', file)
      if (file) {
        if (type == 'view') {
          previewFile(file, data.fileName)
        } else {
          downloadFile(file, data.fileName)
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('handleDownloadIAp12 error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoad(false)
    doneLoading()
  }

  if (isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <>
      <Panel
        header={schema?.header}
        shaded={shaded}
        collapsible={collapsible}
        defaultExpanded={defaultExpanded}
        bordered={bordered}
        style={props.style ? props.style : undefined}
      >
        {isLoad && <OverlayLoader />}

        <Table
          //autoHeight={true}
          autoHeight={schema?.values ? schema?.values.length < 5 : true}
          height={schema?.values?.length > 5 ? 400 : undefined}
          wordWrap
          data={schema?.values || []}
        >
          <Column width={90} align="center" fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          <Column minWidth={350} width={500} flexGrow={1}>
            <HeaderCell>ชื่อไฟล์</HeaderCell>
            <Cell dataKey="fileName" />
          </Column>
          <Column width={220}>
            <HeaderCell>โดย</HeaderCell>
            <Cell dataKey="uploadBy" />
          </Column>
          <Column width={200}>
            <HeaderCell>วันที่อัปโหลด</HeaderCell>
            <Cell dataKey="uploadDate" />
          </Column>
          <Column width={90} align="center" fixed="right">
            <HeaderCell></HeaderCell>

            <Cell>
              {(rowData, index) => {
                return (
                  <>
                    <ButtonToolbar>
                      <ButtonGroup>
                        <TooltipButton
                          isStart={true}
                          icon="eye"
                          tooltip={`แสดง`}
                          // buttonClass="rs-btn-ghost-info"
                          // iconClass={'bt-gost-icon-radius-all-info'}
                          onClick={(e) => handleDownloadIAp12(rowData, 'view')}
                        />
                        <TooltipButton
                          isStart={false}
                          icon="download"
                          tooltip={`ดาวน์โหลด`}
                          onClick={(e) => handleDownloadIAp12(rowData, 'download')}
                        />
                        {/* <IconButton
                          appearance="ghost"
                          icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                          onClick={() => {
                            handleDownloadIAp12(rowData, 'view')
                          }}
                        />
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                          onClick={() => {
                            handleDownloadIAp12(rowData, 'download')
                          }}
                        /> */}
                      </ButtonGroup>
                    </ButtonToolbar>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
